import type { ListTileSpec } from "../ListTiles";
import { pct, fmtCount } from "../listMath";

export interface CpTileRow {
  category?: string | null;
  dualRoleBuyerCp?: boolean | null;
  contactCount: number;
  engaged?: boolean;
  capitalProfile: { minDealSize?: string | null; maxDealSize?: string | null; sweetSpot?: string | null } | null;
}

const hasRange = (r: CpTileRow) => !!(r.capitalProfile?.minDealSize || r.capitalProfile?.maxDealSize || r.capitalProfile?.sweetSpot);

export function capitalProviderTiles(rows: CpTileRow[]): ListTileSpec[] {
  const n = rows.length;
  const alsoBuyers = rows.filter((r) => r.category === "Buyer Network" || r.dualRoleBuyerCp).length;
  const ranged = rows.filter(hasRange).length;
  const withContact = rows.filter((r) => r.contactCount > 0).length;
  const engaged = rows.filter((r) => r.engaged).length;
  const cov = (covered: number, title: string) => ({ covered, total: n, title });
  return [
    { key: "total", label: "Providers", value: n, sub: `${fmtCount(alsoBuyers)} also ${alsoBuyers === 1 ? "a buyer" : "buyers"}` },
    { key: "range", label: "With a deal range", value: ranged, sub: `${pct(ranged, n)}% have a range`, coverage: cov(ranged, `${fmtCount(ranged)} with a deal range`) },
    { key: "contact", label: "With a contact", value: withContact, sub: `${pct(withContact, n)}% have a contact`, coverage: cov(withContact, `${fmtCount(withContact)} with a contact`) },
    { key: "engaged", label: "Spoken to", value: engaged, sub: `${pct(engaged, n)}% of providers`, coverage: cov(engaged, `${fmtCount(engaged)} spoken to`) },
  ];
}
